/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Nopublicsessions2Inputs */

const zh_learn_nopublicsessions2 = /** @type {(inputs: Learn_Nopublicsessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂时还没有公开学习资源。`)
};

const en_learn_nopublicsessions2 = /** @type {(inputs: Learn_Nopublicsessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No public learning resources available yet.`)
};

const es_learn_nopublicsessions2 = /** @type {(inputs: Learn_Nopublicsessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay recursos públicos disponibles.`)
};

/**
* | output |
* | --- |
* | "No public learning resources available yet." |
*
* @param {Learn_Nopublicsessions2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_nopublicsessions2 = /** @type {((inputs?: Learn_Nopublicsessions2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Nopublicsessions2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_nopublicsessions2(inputs)
	if (locale === "en") return en_learn_nopublicsessions2(inputs)
	return es_learn_nopublicsessions2(inputs)
});
export { learn_nopublicsessions2 as "learn_noPublicSessions" }